import { render, staticRenderFns } from "./PlanSetting.vue?vue&type=template&id=34b362a5&scoped=true"
import script from "./PlanSetting.vue?vue&type=script&lang=js"
export * from "./PlanSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b362a5",
  null
  
)

export default component.exports